import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Store for navigate function
let navigationFunction = null;

// Navigation utility function
export const navigate = (...args) => {
    if (!navigationFunction) {
        console.error("Navigation not initialized");
        return;
    }
    navigationFunction(...args);
};

// Simple wrapper component
export const NavigationWrapper = ({ children }) => {
    const navigate = useNavigate();
      
    useEffect(() => {
        navigationFunction = navigate;
    }, [navigate]);

    return children;
};